import React, { useState,useEffect } from 'react';
import { Outlet, useNavigate, useLocation, matchRoutes } from 'react-router-dom';
import { Title, Meta } from 'react-meta-elements';
import { Image, Layout, Menu } from 'antd';
import router from 'Src/router';
import Logo from 'Src/assets/3.0官网/boarStationLogo.png';
import './index.less';

const { Header, Content } = Layout;

function HMyun3() {
  const navigate = useNavigate();
  const location = useLocation();
  // 导航栏数据
  const [items] = useState(
    router
      .filter((el) => el.isThreeRouter)[0]
      .children.map((el) => ({
        key: el.copyPath || el.path,
        label: el.title
      }))
  );

  // 设置菜单栏高亮
  const [defaultSelectedKeys, setDefaultSelectedKeys] = useState([]);
  const [defaultOpenKeys, setDefaultOpenKeys] = useState([]);
  const [isInit, setIsInit] = useState(false);

  // 路由跳转
  const toSwitch = (menuItem) => {
    if (menuItem.key === 'tmp-7') return navigate('/');
    return navigate(menuItem.key);
  };

  useEffect(() => {
    // 依赖于location的路由信息
    // 使用matchRoutes方法，第一参数是路由映射表信息，第二个参数是当前路由地址，返回值要么是数组要么是null
    const routes = matchRoutes(router, location.pathname);
    let pathArr = [];
    if (routes) {
      routes.forEach((el) => {
        const path = el.route.path;
        if (path) {
          pathArr = [];
          pathArr.push(path);
        }
      });
    }
    setDefaultSelectedKeys(pathArr);
    setDefaultOpenKeys(pathArr);
    setIsInit(true);
    console.log(router);
  }, [location.pathname]);

  if (!isInit) return null;
  return (
    <div className="box">
      {/* 设置浏览器标签title和meta描述和icon */}
      <Title>
        {
          router[2].children.find((el) => {
            return location.pathname === el.path || location.pathname === el.copyPath;
          }).browserTitle
        }
      </Title>
      <Meta
        name="describe"
        content={
          router[2].children.find((el) => {
            return location.pathname === el.path || location.pathname === el.copyPath;
          }).describe
        }
      ></Meta>
      <Layout className="layout">
        <Header>
          <div className="headLogo">
            <Image src={Logo} width={30} />
            <span>互牧云公猪站管理系统v2.0</span>
          </div>
          <Menu
            theme="dark"
            mode="horizontal"
            defaultSelectedKeys={defaultSelectedKeys}
            defaultOpenKeys={defaultOpenKeys}
            items={items}
            onClick={toSwitch}
          />
          <div className="register">
            <p
              onClick={() => {
                navigate('/');
              }}
            >
              关于互牧
            </p>
          </div>
        </Header>
        <Content>
          <Outlet />
        </Content>
      </Layout>
    </div>
  );
}

export default HMyun3;
